<template>
<v-app>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <v-container v-if="loading_page === false">
        <v-row class="justify-center">
            <v-col cols="11" sm="10" md="11" lg="5" xl="6">
                <div class="text-center title_size_thank_you_order_online_pickup">เราได้รับออเดอร์ของคุณแล้ว</div>
                <div class="img_thank_you_order_online_pickup ">
                    <img :src="beforeImage">
                </div>
                <div class="d-flex justify-center mb-3">
                    <div class="text-center titleshort_size_thank_you_order_online_pickup">กรุณาถ่ายภาพหน้าจอหรือเปิดหน้านี้</div>
                </div>
                <div class="d-flex justify-center mb-3">
                    <div class="text-center titleshort_size_thank_you_order_online_pickup">เพิ่อเป็นหลักฐานยืนยัน</div>
                </div>

                <div class="text-center titlenote_size_thank_you_order_online_pickup mb-3">ออเดอร์ {{ number_order }}</div>
                <div class="titlenote_size_thank_you_order_online_pickup mb-3">ชื่อ: {{ name }}</div>
                <div class="titlenote_size_thank_you_order_online_pickup mb-3">เบอร์โทร: {{ tel }}</div>
                <div class="titlenote_size_thank_you_order_online_pickup mb-3">เวลารับอาหาร: {{ time }}</div>

                <div class="mb-3">
                    <v-simple-table>
                        <thead>
                            <tr>
                                <th class="border_thank_you_order_online_pickup">
                                    อาหาร
                                </th>
                                <th class="border_thank_you_order_online_pickup">
                                    จำนวน
                                </th>

                                <th class="text-right border_thank_you_order_online_pickup">
                                    รวม
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(detail,index) in data" :key="index">
                                <td class="border_thank_you_order_online_pickup" width="60%">
                                    {{ detail.foodName }} ({{ detail.price }})
                                </td>
                                <td class="border_thank_you_order_online_pickup" width="20%">
                                    {{ detail.amount }}
                                </td>
                                <td class="text-right border_thank_you_order_online_pickup" width="20%">
                                    {{ detail.price * detail.amount }}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-right border_thank_you_order_online_pickup" colspan="2">
                                    รวม
                                </td>
                                <td class="text-right border_thank_you_order_online_pickup">
                                    {{ resultPrice }}
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                </div>

                <div class="text-center titlenote_size_thank_you_order_online_pickup mb-3">เมื่อคุณมารับอาหารกรุณาแจ้งชื่อที่เค้าเตอร์หน้าร้าน</div>
                <div class="text-center titlenote_size_thank_you_order_online_pickup red--text mb-3">
                    *หากท่านไม่มารับอาหาร ภายในเวลาที่บอกไว้เกิน 30 นาที*
                </div>
                <div class="text-center titlenote_size_thank_you_order_online_pickup red--text mb-3">
                    *ทางร้านขอสงวนสิทธิ์ยกเลิกออเดอร์ของท่าน*
                </div>
                <div class="text-center title_thank_you_order_online_pickup mb-3">ขอบคุณที่ให้เราเป็นส่วนหนึ่งของมื้ออาหารแสนอร่อย</div>
                <div class="text-center">
                    <v-btn rounded :style="{background: bg_color}" width="100%" height="65" @click="link()">กลับไปหน้าเว็บไซต์</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</v-app>
</template>

<script>
import {
    HTTP
} from "@/axios.js"
import before_image from "@/assets/new_logologinandtkfull.png";
export default {
    name: 'thankYouOrderOnlinePickUp',
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    data() {
        return {
            loading_page: true,
            beforeImage: before_image,
            bg_color: 'linear-gradient(to top, #038cc1 , #55c0e9)',
            number_order: null,
            name: null,
            tel: null,
            time: null,
            data: [],
        }
    },
    methods: {
        async colorRestaurant() {
            HTTP.get('/showColor')
                .then((response) => {
                    if (response.data.successful === true) {
                        this.bg_color = response.data.color_code
                        this.beforeImage = response.data.logo_image
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                    if (error.response.status === 500) {
                        this.$router.push('/nametakeoutuser')
                    }

                })
        },
        async orderDetail() {
            this.loading_page = true
            this.number_order = null
            this.name = null
            this.tel = null
            this.time = null
            this.data = []
            HTTP.get('/customer/orderdetail/' + this.$route.params.token, {
                    headers: {
                        "Authorization": `Bearer ${this.$store.state.token}`
                    }
                })
                .then((response) => {
                    if (response.data.successful === true) {
                        let detail = response.data.detail
                        this.number_order = detail.orderNumber
                        this.name = detail.name
                        this.tel = detail.tel
                        this.time = detail.time
                        this.data = detail.orderDetailList
                        this.loading_page = false
                    }
                }).catch((error) => {
                    if (error.response.status === 401) {
                        this.$store.commit('logOutSuccess')
                        this.$router.push('/login')
                    }
                })

        },
        async link() {
            window.location.href = 'https://the-chalotte.com/'
        }
    },
    computed:{
        resultPrice(){
            let resultAll = this.data.map((detail) => {
                return detail.price * detail.amount
            })

            return resultAll.reduce((sum, number) =>{ return sum + number }, 0)
        }
    },
    created() {
        this.$store.commit('clearCartListUser')
        this.$store.commit('clearCartTakeOutTableListUser')
        this.$store.commit('clearCartListUserTakeOut')
        this.$store.commit('clearCartOrderOnlineUser')
    },
    mounted() {
        this.colorRestaurant()
        this.orderDetail()
    }
}
</script>

<style scoped>
.img_thank_you_order_online_pickup {
    width: 50%;
    margin: auto;
}

.img_thank_you_order_online_pickup>img {
    max-width: 100%;
}

.title_size_thank_you_order_online_pickup {
    font-size: 24px;
}

.titleshort_size_thank_you_order_online_pickup {
    font-size: 26px;
    border-bottom: #fb8c00 2px solid;
    color: #fb8c00;
    display: inline-block;
}

.titlenote_size_thank_you_order_online_pickup {
    font-size: 18px;
}

.border_thank_you_order_online_pickup {
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
}

.title_thank_you_order_online_pickup {
    font-size: 25px;
    /* color: #fff; */
}
</style>
